<template>
  <vx-card>
    <vs-input
      class="w-full mb-4"
      v-validate="'required|min:6'"
      data-vv-validate-on="blur"
      label="Заголовок новости"
      name="Измененный заголовок"
      v-model="simpleNews.title"
    />
    <span class="text-danger text-sm">{{
      errors.first("Измененный заголовок")
    }}</span>

    <quill-editor
      name="Измененное описание"
      data-vv-validate-on="blur"
      v-validate="'required'"
      v-model="simpleNews.body"
      :options="editorOption"
    />
    <span class="text-danger text-sm">{{
      errors.first("Измененное описание")
    }}</span>

    <picture-input
      ref="pictureInput"
      class="mt-10 z-10"
      @change="onChange"
      width="200"
      height="200"
      margin="1"
      accept="image/jpeg,image/png"
      size="15"
      buttonClass="vs-component vs-button vs-con-loading__container vs-button-primary vs-button-relief"
      :prefill="simpleNews.image"
      :customStrings="{
        upload: '<h1>Загрузить изображение</h1>',
        drag: 'Загрузите изображение',
        change: 'Изменить изображение',
        remove: 'Удалить изображение',
        select: 'Выбрать изображение',
      }"
    >
    </picture-input>

    <vs-button
      @click="updateNews"
      :disabled="!validateForm"
      class="mr-5 vs-con-loading__container"
      ref="loadableButton"
      type="relief"
    >
      Обновить
    </vs-button>

    <vs-button
      @click="deleteNews"
      class="vs-con-loading__container"
      ref="loadableButton"
      type="relief"
      color="danger"
    >
      Удалить
    </vs-button>
  </vx-card>
</template>

<script>
import { API_URL } from "@/.env";
import PictureInput from "vue-picture-input";

import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

export default {
  data: () => ({
    simpleNews: [],
    editorOption: {
      placeholder: "Введите текст",
    },
    BASE_URL: API_URL,
  }),
  components: {
    PictureInput,
    quillEditor,
  },
  watch: {},
  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.simpleNews.title !== "" &&
        this.simpleNews.body !== ""
      );
    },
  },
  methods: {
    notification(title, message, color) {
      this.$vs.notify({
        title: title,
        text: message,
        color: color,
        position: "top-center",
        time: "4000",
        icon: "delete",
      });
    },
    formatDate(date) {
      let now = new Date(date);

      let options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      };

      return now.toLocaleString("ru-ru", options);
    },
    onChange() {
      let payload = {
        imageFile: this.$refs.pictureInput.file,
      };

      this.uploadImage(payload);
    },
    uploadImage(data) {
      this.$load(async () => {
        let res = await this.$api.news.updateNewsImage(
          this.$route.params.id,
          data
        );

        if (res.status == 200) {
          this.notification(
            "Успешно",
            "Изображение успешно обновлено",
            "success"
          );
        } else {
          this.notification(
            "Ошибка",
            "Не удалось обновить изображение",
            "danger"
          );
        }
      });
    },
    updateNews() {
      let payload = {
        title: this.simpleNews.title,
        body: this.simpleNews.body,
      };

      this.$load(async () => {
        let res = await this.$api.news.updateOneNews(
          this.$route.params.id,
          payload
        );

        if (res.status == 200) {
          this.notification("Успешно", "Новость обновлена", "success");
        } else {
          this.notification("Ошибка", "Не удалось обновить новость", "danger");
        }
      });
    },
    getSimpleNews(id) {
      this.$load(async () => {
        let res = (await this.$api.news.getOneNews(id)).data;

        let simpleNews = res;

        simpleNews.date_created = this.formatDate(simpleNews.date_created);
        simpleNews.image =
          simpleNews.image !== null ? this.BASE_URL + simpleNews.image : "";

        this.simpleNews = simpleNews;
      });
    },
    deleteNews() {
      let idNews = this.$route.params.id;

      this.$load(async () => {
        await this.$api.news.deleteNews(idNews).then((response) => {
          if (response.status == 200) {
            this.notification("Успешно", "Новость удалена", "success");
            this.$router.push({ name: "news" });
          } else {
            this.notification("Ошибка", "Не удалось удалить новость", "danger");
          }
        });
      });
    },
  },
  created() {},
  mounted() {
    this.getSimpleNews(this.$route.params.id);
  },
};
</script>